import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GuidedTourService {
  currentStep$ = new BehaviorSubject<number>(0);
  showTour$ = new BehaviorSubject<boolean>(false);
  announcementSubject = new BehaviorSubject<any>(null);
  showTourOnTabChange$ = new BehaviorSubject<any>(false);
  constructor(private http: HttpClient) { }

  
  startTour() {
    let showTourFlag = localStorage.getItem('showTourFlag') === 'true' ? true : false;
    this.currentStep$.next(0);
    this.showTour$.next(showTourFlag);
  }
  nextStep(max: number) {
    const next = this.currentStep$.value + 1;
    if (next < max) {
      this.currentStep$.next(next);
    } else {
      this.endTour();
    }
  }
  prevStep() {
    const prev = this.currentStep$.value - 1;
    if (prev >= 0) {
      this.currentStep$.next(prev);
    }
  }
  endTour() {
    this.showTour$.next(false);
  }

  getAnnouncements(){
    const headers = new HttpHeaders({
      userId: localStorage.getItem('userId'),
    });
    return this.http.post<any>(`${environment.apiUrl}/v1/announcements?limit=10&page=1`, null, {
      headers: headers,
    });
  }
  saveAnnouncements(payload: any) {
    return this.http.post<any>(`${environment.apiUrl}/v1/stopAnnouncements`, payload);
  }
}